import Banner from '../../sections/common/banner';

import { data } from '../../../globals/data/electronics';

import SectionServices3 from '../../sections/home/index3/section-services3';
import SectionWhatWeDo2 from '../../sections/home/index3/section-what-we-do2';
import SectionWhyChooseUs3 from '../../sections/home/index3/section-why-choose-us3';
import SectionBlogs2 from '../../sections/home/index2/section-blogs2';
import SectionWhyChooseUs2 from '../../sections/home/index2/section-why-choose-us2';
import SectionWhyChooseUs4 from '../../sections/home/index2/section-why-choose-us4';
import SectionServices5 from '../../sections/home/index3/section-services5';
import ServicesPageHelmet from '../../helmets/ServicesPageHelmet';

export default function ElectronicsPage() {
  console.log('data.services', data.services);
  return (
    <>
      <ServicesPageHelmet />

      <Banner _data={data.banner} />
      <SectionWhyChooseUs4 _data={data.whychoosus} />
      <SectionServices5 data={data.allservices} key='services-section' />
    </>
  );
}
